import { useRouteLoaderData } from '@remix-run/react';
import { useEffect } from 'react';

/**
 * Custom hook to manage the favicon element in the document head.
 * Created to solve the issue where the Chrome browser is looking
 * for the default favicon in the wrong location, due to hydration
 * errors in the /player route.
 */
export function useFavicon() {
  const { faviconSrc } = useRouteLoaderData<any>('root');

  useEffect(() => {
    if (!faviconSrc) return;

    let link: HTMLLinkElement | null =
      document.querySelector('link[rel="icon"]');

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.type = 'image/x-icon';
    link.href = faviconSrc;
  }, [faviconSrc]);
}
